import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import {Modal, ModalHeader,ModalBody, Row, Col, PopoverBody, Popover,Tooltip} from "reactstrap";
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { showNotification } from "components/Common/notification";
import Switch from "react-switch";
import CardItem from "components/PurpleTheme/CardItem";
import LineChart from "../SLODashboard/LineChart";
import {
  getPingMonitors as onGetPingMonitors,
  getPingMonitorDetail as onGetPingMonitorDetail,
  mapEndpointToService as onMapEndpointToService,
  getServices as onGetServices,
  getPingMonitors,
  toggleEndpoint,
  getTimestamps as onGetTimestamps,
  getUptimeCheckFailures as onGetUptimeCheckFailures,
  deleteEndpoint as onDeleteEndpoint,

} from "../../store/actions";
import '../../pages/Service/services.scss';

import { Table } from "reactstrap";
import OnEditModal from "./OnEditModal";
import { useSearchParams } from "react-router-dom";

const Endpoint = props => {

  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [currentHoverItem, setCurrentHoverItem] = useState(null);
  const [endpointstatus, setEndpointstatus] = useState({});
  const [endpointId, setEndpointId] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [allItemsChecked, setAllItemsChecked] = useState(false);
  const [allEndpointIds, setAllEndpointIds] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [serviceNames, setServiceNames] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [endpointNames, setEndpointNames] = useState([]);
  const [btnHover, setBtnHover] = useState(false);
  const [loading, setLoading] = useState(false);
  const[popoverOpen1,setPopoverOpen1] = useState({});
  const [tooltipOpenState, setTooltipOpenState] = useState({});
  const [expandedEndpoint, setExpandedEndpoint] = useState(null);
  const [EndpointDeleteModal, setEndpointDeleteModal] = useState(false);
  const [EndpointForDelete, setEndpointForDelete] = useState(null);
  const { uptimeCheckFailures } = useSelector((state) => state.PingMonitor);
  const { pingMonitors } = useSelector(state => ({
    pingMonitors: state.PingMonitor.pingMonitors || [],
  }));
  const { timestamps } = useSelector(state => ({ timestamps: state.PingMonitor.timestamps}));
  const services = useSelector(state =>
    state.Service.services
  );

  const handleMouseOverEndpoint = (key) => {
    toggleTooltip(key, true);
  };
  const toggletip = (id, type) => {
    setTooltipOpenState((prevState) => ({
      ...prevState,
      [`${type}-${id}`]: !prevState[`${type}-${id}`],
    }));
  };

  const handleMouseLeaveEndpoint = (key) => {
    toggleTooltip(key, false);
  };
  const setTimeframe = (hours) => {
    const timeframeInMinutes = hours * 60;
    dispatch(onGetTimestamps({
      'endpoint_id': expandedEndpoint,
      'duration_in_minutes': timeframeInMinutes
    }))
  }

    const handleEndpointDeleteModal=(endpoint)=> {
      setEndpointDeleteModal(current => !current);
      setEndpointForDelete({"id":endpoint.id, "name":endpoint.name, "url":endpoint.endpoint})
    }

    const cancelUserDeleteModal = () => {
      setEndpointDeleteModal(current => !current);
      setEndpointForDelete(null)
    }

    const handleEndpointDelete = async (endpoint_id) => {
      try {
        const payload = {endpoint_id}
        dispatch(onDeleteEndpoint(payload));
        setEndpointDeleteModal(false);
        setEndpointForDelete(null);
        window.location.reload()
      } catch (error) {
        console.error('Error:', error);
      }
    }

  const [searchParams,setSearchParams] = useSearchParams();
  useEffect(() => {
    const endpointIdFromParams = searchParams.get("endpoint_id");
    if (endpointIdFromParams) {
      setExpandedEndpoint(endpointIdFromParams);
    }
  }, [searchParams]);

  useEffect(() => {
    dispatch(onGetPingMonitors());
    dispatch(onGetServices())
  }, [onGetPingMonitors, onGetServices, showModal])

  useEffect(() => {
    const names = services?.reduce((acc, service) => {
      acc[service.id] = service.name;
      return acc;
    }, {});
    setServiceNames(names);
    const monitorNames = pingMonitors.reduce((acc, monitor) => {
      acc[monitor.id] = monitor.name;
      return acc;
    }, {});
    setEndpointNames(monitorNames)
  }, [services, pingMonitors])

  useEffect(() => {
    const endpointIds = [];
    pingMonitors.map((item, index) => (
      endpointIds.push(item.id)
    ))
    setAllEndpointIds(endpointIds);
    const options = services?.map((service) => ({
      value: service.id,
      label: service.name
    }));
    setServiceOptions(options);
  }, [pingMonitors])

  useEffect(() => {
    if (endpointId) {
      const payload = {
        endpoint_id: endpointId,
      }
      dispatch(onGetUptimeCheckFailures(payload));
    }
  }, [dispatch, endpointId]);


  const onEditEndpoint = (endpointId) => {
    setEndpointId(endpointId);
    dispatch(onGetPingMonitorDetail(endpointId));
    toggle();
    loadData();
  }

  const loadData = () => {
    setLoading(true)
    setTimeout(() => {
      dispatch(onGetPingMonitors())
      setLoading(false)
    }, 800)
  }

  const toggle = () => {
    if (modal) {
      setEndpointId(null);
      setModal(false);
    } else {
      setModal(true);
    }
  }

  const toggleModal = () => {setShowModal(!showModal)}

  const handleServiceFormChange = (selectedOption) => {
    setSelectedService(selectedOption);
  };

  const cancelMapServiceModal = () => {
    setShowModal(false)
  }

  const toggleTooltip = (key, isOpen) => {
    setPopoverOpen1(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };
  const toggleEndpointStatus = (endpointId) => {
    let payload = {"endpoint_id": endpointId};
    const newStatus = !endpointstatus[endpointId];

    dispatch(toggleEndpoint(payload));
    setEndpointstatus((prevStatus) => ({
        ...prevStatus,
        [endpointId]: newStatus
    }));

    if (newStatus) {
        showNotification("success", "Endpoint Monitoring has been successfully enabled.");
    } else {
        showNotification("success", "Endpoint Monitoring has been successfully disabled.");
    }

    setTimeout(() => {
        dispatch(onGetPingMonitors());
    }, 700);
};

  useEffect(() => {
    if (pingMonitors.length > 0) {
      const updatedStatus = {};
      pingMonitors.forEach((monitor) => {
        updatedStatus[monitor.id] = monitor.enabled;
      });
      setEndpointstatus(updatedStatus);
    }
  }, [pingMonitors]);

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    const endpointId = params.get("endpoint_id");

    if (endpointId) {
      const payload = {endpoint_id: endpointId};
      dispatch(onGetUptimeCheckFailures(payload));
      dispatch(
          onGetTimestamps({
            endpoint_id: endpointId,
            duration_in_minutes: 60,
          })
      );
    }
  }, [dispatch, searchParams]);


  const OffSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const customOptionRenderer = (option) => {
    if (option.value === "/add-service") {
      return (
        <div
          className="d-flex justify-content-center align-items-center gap-2 btn btn-soft-primary"
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{cursor:"pointer"}}>
          <i className={`fas fa-plus font-size-14 ${btnHover ? 'text-white' : 'text-primary'}`} />
          <span>
            {option.label}
          </span>

        </div>
      );
    } else {
      return option.label;
    }
  };

  const handleServiceMapping = () => {
    let payload =
    {
      'application_service_id': selectedService.value,
      'endpoint_ids' : selectedItems
    }
    dispatch(onMapEndpointToService(payload));
    setAllItemsChecked(false);
    setShowModal(false);
    showNotification("success", "Successfully mapped")
    setSelectedItems([]);
    setTimeout(() => {
      dispatch(getPingMonitors())
    }, 700)
    // window.location.reload();
  }

  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',// Background color of dropdown options
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      zIndex: 200,
      // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100,
    }),
  };

  const formatDate = (date) => {
    const utcDate = new Date(date);
    const options = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    return utcDate.toLocaleDateString(undefined, options);
  }

  const handleCheck = (endpointId, status) => {
    if (status === 'all') {
      if (allItemsChecked) {
        setSelectedItems([]);
      } else {
        setSelectedItems(endpointId);
      }
      setAllItemsChecked(!allItemsChecked);
    } else if (status === 'itemChecked') {
      const updatedSelectedItems = selectedItems.includes(endpointId)
        ? selectedItems.filter(id => id !== endpointId)
        : [...selectedItems, endpointId];

      setSelectedItems(updatedSelectedItems);

      if (updatedSelectedItems.length === allEndpointIds.length) {
        setAllItemsChecked(true);
      } else {
        setAllItemsChecked(false);
      }
    }
  }
  const endpointStatus = (endpoint) => {
    if(!endpoint.enabled || endpoint.last_ping === null) {
      return 'bg-light'
    } else if(endpoint.last_ping_successful) {
      return 'bg-success'
    } else {
      return 'bg-danger'
    }
  }
  const deleteItem = (endpointId) => {
    const updatedSelectedItems = selectedItems.filter(id => id !== endpointId)
    setSelectedItems(updatedSelectedItems);
  }
  const headers = [
    {name: "Name", width:2},
    {name:"Endpoint", width:3},
    {name:"Service", width:2},
    {name:"Status", width:1},
    {name:"Last Ping", width:2},
    {name:"Action", width:1}
  ]

  const itemsPerPage = 6;
  const total_failures = uptimeCheckFailures?.total_count || 10;
  const [selectedPage, setSelectedPage] = useState(1);
  const totalPages = Math.ceil(total_failures / itemsPerPage);
  let startPage = Math.max(selectedPage - 1, 1);
  const [isLoading, setIsLoading] = useState(false);

  let endPage = Math.min(startPage + 2, totalPages);
  if (endPage === totalPages) {
    startPage = Math.max(totalPages - 2, 1);
  }
  const handlePageClick = (pageNumber,endpointId) => {
    setIsLoading(true);

    if (pageNumber < 1 || pageNumber > totalPages) {
      setIsLoading(false);
      return;
    }

    const payload = {
      endpoint_id: endpointId,
      page: pageNumber,
      limit: itemsPerPage
    };

    dispatch(onGetUptimeCheckFailures(payload));
    setSelectedPage(pageNumber);
  };
  return (
    <React.Fragment>
      <Row className="d-flex align-items-center mb-2">
          <Col lg="9" className="align-items-center">
            <div className="d-flex gap-1 align-items-start text-white">
              <h4 className="mb-0">Monitored Endpoints</h4>
            </div>
          </Col>
          <Col lg="3">
            <div className="d-flex gap-2 align-items-center justify-content-end">
              <button onClick={() => setShowModal(!modal)} disabled={selectedItems.length === 0} className="btn btn-primary">
                Map to service
              </button>
              <Link to={`/add-ping-monitoring`} className="btn btn-primary bx-pull-right w-md">
                Add new
              </Link>
            </div>
          </Col>
      </Row>
    <OnEditModal services={serviceOptions} isOpen={modal} serviceId={endpointId} toggle={toggle} />

    {loading ? (
      <div className="w-full d-flex justify-content-center align-items-center">
        <div role="status" className="ms-2 spinner-border text-primary">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    ) : (
      <div className="card-container">
        <div className="header d-flex">
          <Row className="w-100">
            <Col lg={1} className="d-flex align-items-center justify-content-center mt-2 ml-3">
              <div>
                <span role="button" onClick={() => handleCheck(allEndpointIds, 'all')}>
                  <i
                    style={{ paddingLeft: '10px' }}
                    className={`bx font-size-24 ${
                      allItemsChecked ? 'bx-checkbox-checked' : 'bx-checkbox'
                    }`}
                  />
                </span>
              </div>
            </Col>
            {headers.map((header, index) => (
              <Col md={header.width} lg={header.width} key={index}>
                <div className="d-flex align-items-center justify-content-center p-2 py-3">
                  {header.name}
                </div>
              </Col>
            ))}
          </Row>
        </div>

        {pingMonitors.map((endpoint, index) => (
          <React.Fragment key={endpoint.id}>
            <CardItem
              className="card-item"
              bgColor={currentHoverItem === endpoint.id ? '#382d45' : ''}
              cursor="pointer"
              onMouseEnter={() => setCurrentHoverItem(endpoint.id)}
              onMouseLeave={() => setCurrentHoverItem(null)}
            >
              <div className="d-flex justify-content-evenly text-center py-3 w-100"
                   onClick={() => {
                     const newExpandedEndpoint = expandedEndpoint === endpoint.id ? null : endpoint.id;
                     setExpandedEndpoint(newExpandedEndpoint);
                     if (newExpandedEndpoint) {
                       const payload = {
                         endpoint_id: endpoint.id,
                       }
                       dispatch(onGetUptimeCheckFailures(payload));
                       dispatch(onGetTimestamps({
                         'endpoint_id': endpoint.id,
                         'duration_in_minutes': 60
                       }))
                     }
                   }}
                   onMouseEnter={() => {
                     setCurrentHoverItem(endpoint.id);
                   }}
                   onMouseLeave={() => {
                     setCurrentHoverItem(null);
                   }}>
                <Col lg={1}>
                <div >
                  <span role="button" onClick={() => handleCheck(endpoint.id, 'itemChecked')}>
                    <i
                      className={`bx font-size-24 ml-2 ${
                        selectedItems.includes(endpoint.id) ? 'bx-checkbox-checked' : 'bx-checkbox'
                      }`}
                    />
                  </span>
                </div>
                </Col>
                <Col lg={2}>
                <a className="text-start resource-name-truncate">
                  {endpoint.name}
                </a>
                </Col>
                <Col lg={3}>
                  <div
                    id={`endpoint_tooltip_${endpoint?.id}`}
                    className="resource-name-truncate"
                    style={{
                      display: 'table-cell',
                      maxWidth: 'min-content',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      fontSize: '14px',
                    }}
                    onMouseEnter={() => handleMouseOverEndpoint(endpoint.id)}
                    onMouseLeave={() => handleMouseLeaveEndpoint(endpoint.id)}
                  >
                    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                      {endpoint.endpoint.length > 25
                        ? endpoint.endpoint.substring(0, 25) + '...'
                        : endpoint.endpoint}
                      <Link to={endpoint.endpoint} target="_blank" style={{ paddingLeft: '5px' }}>
                        <i className="bx bx-link-external font-size-16"></i>
                      </Link>
                    </div>
                    <Popover
                      placement="top"
                      isOpen={popoverOpen1[endpoint.id] || false}
                      target={`endpoint_tooltip_${endpoint?.id}`}
                    >
                      <PopoverBody>{endpoint.endpoint}</PopoverBody>
                    </Popover>
                  </div>
                </Col>
                <Col lg={2}>
                  <Link to={`/temperstack-notifications/${endpoint.application_service_id}`}>
                    <span className="resource-name-truncate">
                      {serviceNames[endpoint.application_service_id]}
                    </span>
                  </Link>
                </Col>
                <Col lg={1}>
                  <div className="d-flex justify-content-center">
                    <div
                      className={`text-center h-4 w-4 rounded-circle ${endpointStatus(endpoint)}`}
                      style={{ height: '14px', width: '14px' }}
                    ></div>
                  </div>
                </Col>
                <Col lg={2}>
                  {endpoint.last_ping === null ? '--' : formatDate(endpoint.last_ping)}
                </Col>
                <Col lg={1}>
                  <div className="d-flex justify-content-center gap-1">
                    <Link className="text-success" to="/edit-endpoint" state={{endpointId: endpoint?.id}}>
                      <i className="mdi mdi-pencil font-size-22" id={`edittooltip-${index}`} />
                    </Link>
                    <div className="d-flex justify-content-center gap-3">
                      <div id={`TooltipEndpoint-${endpoint.id}`} className="endpoint-icon">
                        <Switch
                          uncheckedIcon={<OffSymbol />}
                          checkedIcon={<OnSymbol />}
                          className="me-1 mb-sm-8  mx-1 my-2"
                          height={16}
                          width={34}
                          onColor="#34c38f"
                          offColor="#f46a6a"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 5px"
                          onChange={() => toggleEndpointStatus(endpoint.id)}
                          checked={endpointstatus[endpoint.id] || false}
                        />
                      </div>
                      <Tooltip
                        placement="top"
                        isOpen={tooltipOpenState[`enable-disable-${endpoint.id}`] || false}
                        target={`TooltipEndpoint-${endpoint.id}`}
                        toggle={() => toggletip(endpoint.id, 'enable-disable')}
                        style={{
                          border: "2px solid #f1b44c",
                          borderRadius: "10px",
                          backgroundColor: "#2a3042",
                          zIndex: 1000
                        }}
                      >
                        Enable/Disable Endpoint
                      </Tooltip>
                    </div>
                    <div className="d-flex justify-content-center">
                      <Link
                        id={`TooltipDelete-${endpoint.id}`}
                        className="mx-auto text-secondary mt-n1"
                        style={{cursor: 'pointer'}}
                        onClick={() => handleEndpointDeleteModal(endpoint)}
                      >
                        <i className="mdi font-size-24 mdi-delete deleteUserIcon text-danger"/>
                      </Link>
                      <Tooltip
                        placement="top"
                        isOpen={tooltipOpenState[`delete-${endpoint.id}`] || false}
                        target={`TooltipDelete-${endpoint.id}`}
                        toggle={() => toggletip(endpoint.id, 'delete')}
                        style={{
                          border: "2px solid #f1b44c",
                          borderRadius: "10px",
                          backgroundColor: "#2a3042",
                          zIndex: 1000
                        }}
                      >
                        Delete Endpoint
                      </Tooltip>
                    </div>
                  </div>
                </Col>
              </div>
              {expandedEndpoint === endpoint.id && (
                <div className="details d-flex flex-column mt-2">
                  <div className="d-flex flex-row gap-3">
                    <div className="line-chart-container" style={{ flex: '1 1 60%' }}>
                      <LineChart
                        height={'280'}
                        chartType={'line'}
                        disableFilters={false}
                        setTimeframe={setTimeframe}
                        timeFrame={1}
                        data={timestamps}
                      />
                    </div>
                    <div className="table-container flex-grow-1 p-2 mt-3" style={{flex: '1 1 40%'}}>
                      <div className="mb-2 d-flex">
                        <h4 className="pe-5 ms-1 w-75">Recent Uptime Check Failures</h4>
                        <div className="d-flex ps-5 ms-3 justify-content-center">
                          <div className="d-flex align-items-center justify-content-center rounded-circle border"
                               style={{
                                 width: '1.5rem',
                                 height: '1.5rem',
                                 backgroundColor: 'transparent',
                                 transition: 'background-color 0.2s'
                               }}
                               onMouseEnter={e => e.currentTarget.style.backgroundColor = '#2a54c2'}
                               onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                            <i className="mdi mdi-chevron-left font-size-16"
                             onClick={() => handlePageClick(Math.max(selectedPage - 1, 1), endpoint.id)}
                             disabled={selectedPage === 1}
                             style={{
                               cursor: 'pointer',
                               opacity: selectedPage === 1 ? 0.5 : 1,
                               transition: 'color 0.2s',
                               ':active': {
                                 color: '#0d6efd'
                               }
                             }}
                             onMouseDown={e => e.currentTarget.style.color = '#0d6efd'}
                             onMouseUp={e => e.currentTarget.style.color = ''}
                             onMouseLeave={e => e.currentTarget.style.color = ''}
                          />
                          </div>
                          <div className="d-flex align-items-center justify-content-center rounded-circle border ms-2"
                               style={{
                                 width: '1.5rem',
                                 height: '1.5rem',
                                 backgroundColor: 'transparent',
                                 transition: 'background-color 0.2s'
                               }}
                               onMouseEnter={e => e.currentTarget.style.backgroundColor = '#2a54c2  '}
                               onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                            <i className="mdi mdi-chevron-right font-size-16"
                             onClick={() => handlePageClick(Math.min(selectedPage + 1, totalPages), endpoint.id)}
                             disabled={selectedPage === totalPages}
                             style={{
                               cursor: 'pointer',
                               opacity: selectedPage === totalPages ? 0.5 : 1,
                               transition: 'color 0.2s',
                               ':active': {
                                 color: '#0d6efd'
                               }
                             }}
                             onMouseDown={e => e.currentTarget.style.color = '#0d6efd'}
                             onMouseUp={e => e.currentTarget.style.color = ''}
                             onMouseLeave={e => e.currentTarget.style.color = ''}
                          />
                          </div>
                        </div>
                      </div>
                      <div style={{height: '20rem', overflowY: 'auto'}}>
                        <Table style={{background: 'transparent'}}>
                          <thead>
                          <tr>
                            <th style={{ background: 'transparent' }}>Failure Occurred At</th>
                            <th style={{ background: 'transparent' }}>Failure Reason</th>
                          </tr>
                          </thead>
                          <tbody>
                        {uptimeCheckFailures && uptimeCheckFailures.failures && uptimeCheckFailures.failures.length > 0 ? (
                            uptimeCheckFailures.failures.map((failure) => (
                              <tr key={failure.id} style={{ background: 'transparent' }}>
                                <td style={{ background: 'transparent' }}>{formatDate(failure.failure_occurred_at)}</td>
                                <td style={{ background: 'transparent',overflowWrap:'anywhere' }}>{failure.failure_reason}</td>
                              </tr>
                            ))
                        ) : (
                            <tr style={{background: 'transparent'}}>
                              <td colSpan="2" style={{background: 'transparent'}}>No failures found</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                        </div>
                        <div className="pt-0">
                        Total Failures: {uptimeCheckFailures?.total_count}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </CardItem>
          </React.Fragment>
        ))}
      </div>
    )}
      <Modal isOpen={showModal} toggle={toggleModal} role="dialog" autoFocus={true} centered backdrop="static"
             size="xl">
    <div>
      <ModalHeader className="border-bottom-2">
        <span className="modal-header-resource">Map Endpoint to Service</span>
      </ModalHeader>
    </div>
    <div className="modal-body">
      <Row className="full-width">
        <Col lg="7" className="">
          <h5 className="text-primary mb-3">Selected Resources</h5>
          {selectedItems.map((item, index) => (
            <div className="d-flex align-items-center gap-2" key={index}>
              <span>{endpointNames[item]}</span>
              <span role="button" onClick={() => deleteItem(item)}>
                <i className="bx bx-x font-size-18" />
              </span>
            </div>
          ))}
        </Col>
        <Col lg="5" className="">
          <h5 className="text-primary select-service mb-3">Select Application Service</h5>
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <div className="mb-2">
                  <Select
                    isClearable
                    options={[...serviceOptions,
                      { value: "/add-service", label: "Add new service" }]}
                    placeholder="Select an Application Service"
                    onChange={(selectedOption) => {
                      if (selectedOption && selectedOption.value === "/add-service") {
                        window.location.href = "/add-service";
                      } else {
                        handleServiceFormChange(selectedOption);
                      }
                    }}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                    getOptionLabel={(option) => customOptionRenderer(option)}
                  />
                </div>
                <Row className="full-width mt-4 pt-4">
                  <Col lg="6" className="mt-4">
                    <a href="#" onClick={(e) => { 
                      e.preventDefault();
                      cancelMapServiceModal();
                      }} className="btn btn-secondary w-md">Cancel</a>
                  </Col>
                  <Col lg="6" className="mt-4">
                    <button disabled={selectedItems.length === 0} onClick={(e) => {
                      e.preventDefault();
                      handleServiceMapping();
                      }} className="btn btn-primary w-md">Map
                      </button>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </Modal>
  {EndpointForDelete && (<Modal
    isOpen={EndpointDeleteModal}
    role="dialog"
    autoFocus={true}
    keyboard={false}
    centered
    backdrop="static"
    data-toggle="modal"
  >
    <ModalHeader className="border-bottom-2">
      Delete this Endpoint?
    </ModalHeader>
    <ModalBody>
      <div className="mb-2"><b>Name:</b> {EndpointForDelete.name}</div>
      <div className="mb-4"><b>Endpoint:</b> {EndpointForDelete.url.length > 50 ? EndpointForDelete.url.slice(0,50) + "..." :EndpointForDelete.url}</div>
      <div className="row text-center">
        <Col lg="6">
          <Link onClick={cancelUserDeleteModal} className="btn btn-secondary w-md">Cancel</Link>
        </Col>
        <Col lg="6">
          <Link
            className="btn btn-danger w-md"
            onClick={() => {
              handleEndpointDelete(EndpointForDelete.id);
            }}
          >
            Confirm
          </Link>
        </Col>
      </div>
    </ModalBody>
  </Modal>)}
</React.Fragment>
  );
};

Endpoint.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onGetServices: PropTypes.func,
};

export default withRouter(Endpoint);
